/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ConfigFirmwareVersionSelect_ConfigFragment = { __typename: 'ConfigurationModel', id: string, shouldUpdateToLatestFirmware?: boolean | null, platform: string, supportedFirmwares: Array<string>, firmware?: { __typename: 'ConfigFirmware', android: { __typename: 'ConfigAndroid', version: any }, scaler?: { __typename: 'ConfigScaler', version: any } | null } | null };

export type ConfigUpdateFirmwareVersionMutationVariables = Types.Exact<{
  input: Types.ConfigurationUpdateAndroidFirmwareInput;
}>;


export type ConfigUpdateFirmwareVersionMutation = { __typename: 'Mutation', configurationUpdateAndroidFirmware: { __typename: 'ConfigurationModel', id: string } };

export type ConfigUpdateFirmwareToLatestFlagMutationVariables = Types.Exact<{
  input: Types.ShouldUpdateToLatestFirmwareInput;
}>;


export type ConfigUpdateFirmwareToLatestFlagMutation = { __typename: 'Mutation', configurationUpdateFirmwareToLatestFlag: { __typename: 'ConfigurationModel', id: string } };

export const ConfigFirmwareVersionSelect_ConfigFragmentDoc = gql`
    fragment ConfigFirmwareVersionSelect_config on ConfigurationModel {
  id
  shouldUpdateToLatestFirmware
  firmware {
    android {
      version
    }
    scaler {
      version
    }
  }
  platform
  supportedFirmwares
}
    `;
export const ConfigUpdateFirmwareVersionDocument = gql`
    mutation ConfigUpdateFirmwareVersion($input: ConfigurationUpdateAndroidFirmwareInput!) {
  configurationUpdateAndroidFirmware(input: $input) {
    id
  }
}
    `;
export type ConfigUpdateFirmwareVersionMutationFn = ApolloReactCommon.MutationFunction<ConfigUpdateFirmwareVersionMutation, ConfigUpdateFirmwareVersionMutationVariables>;

/**
 * __useConfigUpdateFirmwareVersionMutation__
 *
 * To run a mutation, you first call `useConfigUpdateFirmwareVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigUpdateFirmwareVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configUpdateFirmwareVersionMutation, { data, loading, error }] = useConfigUpdateFirmwareVersionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigUpdateFirmwareVersionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfigUpdateFirmwareVersionMutation, ConfigUpdateFirmwareVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfigUpdateFirmwareVersionMutation, ConfigUpdateFirmwareVersionMutationVariables>(ConfigUpdateFirmwareVersionDocument, options);
      }
export type ConfigUpdateFirmwareVersionMutationHookResult = ReturnType<typeof useConfigUpdateFirmwareVersionMutation>;
export type ConfigUpdateFirmwareVersionMutationResult = ApolloReactCommon.MutationResult<ConfigUpdateFirmwareVersionMutation>;
export type ConfigUpdateFirmwareVersionMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfigUpdateFirmwareVersionMutation, ConfigUpdateFirmwareVersionMutationVariables>;
export const ConfigUpdateFirmwareToLatestFlagDocument = gql`
    mutation ConfigUpdateFirmwareToLatestFlag($input: ShouldUpdateToLatestFirmwareInput!) {
  configurationUpdateFirmwareToLatestFlag(input: $input) {
    id
  }
}
    `;
export type ConfigUpdateFirmwareToLatestFlagMutationFn = ApolloReactCommon.MutationFunction<ConfigUpdateFirmwareToLatestFlagMutation, ConfigUpdateFirmwareToLatestFlagMutationVariables>;

/**
 * __useConfigUpdateFirmwareToLatestFlagMutation__
 *
 * To run a mutation, you first call `useConfigUpdateFirmwareToLatestFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigUpdateFirmwareToLatestFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configUpdateFirmwareToLatestFlagMutation, { data, loading, error }] = useConfigUpdateFirmwareToLatestFlagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigUpdateFirmwareToLatestFlagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfigUpdateFirmwareToLatestFlagMutation, ConfigUpdateFirmwareToLatestFlagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfigUpdateFirmwareToLatestFlagMutation, ConfigUpdateFirmwareToLatestFlagMutationVariables>(ConfigUpdateFirmwareToLatestFlagDocument, options);
      }
export type ConfigUpdateFirmwareToLatestFlagMutationHookResult = ReturnType<typeof useConfigUpdateFirmwareToLatestFlagMutation>;
export type ConfigUpdateFirmwareToLatestFlagMutationResult = ApolloReactCommon.MutationResult<ConfigUpdateFirmwareToLatestFlagMutation>;
export type ConfigUpdateFirmwareToLatestFlagMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfigUpdateFirmwareToLatestFlagMutation, ConfigUpdateFirmwareToLatestFlagMutationVariables>;